export class FeatureViews {
  static HomeDashboardFeatureView = "home-dashboard";

  static UserSearchFeatureView = "user-search";
  static UserRegisterFeatureView = "user-register";
  static UserEditFeatureView = "user-edit";

  static CompanySearchFeatureView = "company-search";
  static CompanyRegistrationFeatureView = "company-registration";
  static CompanyEditFeatureView = "company-edit";
  static CompanyCreateFeatureView = "company-create";

  static CampaignSearchFeatureView = "campaign-search";

  static BeneficiarySearchFeatureView = "beneficary-search";
  static BeneficiaryExportFeatureView = "beneficaries-export"
  static BeneficiaryRegistrationBeneficiaryFeatureView = "beneficary-registration-beneficary";
  static BeneficiaryRegistrationDependentFeatureView = "beneficary-registration-dependent";
  static BeneficiaryEditBeneficiaryFeatureView = "beneficary-edit-beneficary";
  static BeneficiaryEditDependentFeatureView = "beneficary-edit-dependent";
  static BeneficiaryRegistrationBeneficiariesFeatureView = "beneficary-registration-beneficaries";
  static BeneficiaryBlockBeneficiariesFeatureView = "beneficiary-block-beneficiaries";
  static BeneficiaryUnblockBeneficiariesFeatureView = "beneficiary-unblock-beneficiaries";

  static BenefitSearch = "benefit-search";
  static BenefitRegistration = "benefit-registration";
  static BenefitEdit = "benefit-edit";

  static SalesHistoryCompanies = "sales-history-companies";
  static SalesHistoryCompany = "sales-history-company";

  static FinancialStatementSearchFeatureView = "financial-statement-search";
  static FinancialStatementBeneficiaryFeatureView = "financial-statement-company";
  static FinancialStatementCompanyFeatureView = "financial-statement-beneficiary";

  static FinancialReportSearchFeatureView = "search-financial-report";

  static NetworkTermSearchFeatureView = "network-term-search";
  static NetworkTermAddFeatureView = "network-term-add";
  static NetworkTermEditFeatureView = "network-term-edit";

  static SearchLpmCompanies = "search-lpm-management";
  static EditLpm = "edit-lpm";
  static AddIndustryDiscounts = "add-industry-discounts";

  static SearchProduct = "search-product";
  static EditProduct = "edit-product";
  static EditProductPricing = "edit-product-pricing";
  static InsertProduct = "insert-product";

  static SearchPractitioner = "search-practitioner";
  static RegisterPractitioner = "register-practitioner";
  static EditPractitioner = "edit-practitoner";

  static SearchClusters = "search-cluster-management";
  static EditClusters = "edit-cluster";
  static AddClusters = "add-cluster";

  static ExtratoLpm = "lpm-statement";
}
